"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroup = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var StyledButtonGroup = styled_components_1.default.div(function (_a) {
    var _b = _a.theme, mediaQueries = _b.mediaQueries, space = _b.space;
    return "\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: -".concat(space[2], ";\n\n    ").concat(mediaQueries.smallAndUp, " {\n      margin-bottom: -").concat(space[3], ";\n      margin-right: -").concat(space[3], ";\n    }\n  ");
});
var StyledButtonGroupItem = styled_components_1.default.div(function (_a) {
    var _b = _a.theme, mediaQueries = _b.mediaQueries, space = _b.space;
    return "\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-bottom: ".concat(space[2], ";\n    width: 100%;\n\n    ").concat(mediaQueries.smallAndUp, " {\n      width: auto;\n      margin-right: ").concat(space[3], ";\n      margin-bottom: ").concat(space[3], ";\n    }\n\n    :empty {\n      display:none;\n    }\n  ");
});
var ButtonGroup = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var id = (0, react_1.useId)();
    return (react_1.default.createElement(StyledButtonGroup, __assign({}, rest), react_1.Children.map(children, function (child, i) { return (react_1.default.createElement(StyledButtonGroupItem, { key: "".concat(id, "-").concat(i) }, child)); })));
};
exports.ButtonGroup = ButtonGroup;
